export const SOFTLINE_API_TASKS = '/task-service/tasks';
export const SOFTLINE_API_TASK_TYPES = '/task-service/tasks/types';
export const SOFTLINE_API_TASK_BY_ID = '/task-service/tasks/{{id}}';
export const SOFTLINE_API_TASKS_BY_WORKFLOW =
  '/task-service/tasks/workflow/{{workflowId}}';

export const SOFTLINE_API_TASK_CHECKPOINTS = '/task-service/tasks/{{taskId}}/checkpoints';
export const SOFTLINE_API_TASK_CHECKPOINT_BY_ID =
  '/task-service/tasks/{{taskId}}/checkpoints/{{checkpointId}}';
export const SOFTLINE_API_TASK_DOCUMENTS = '/task-service/tasks/{{taskId}}/documents';
export const SOFTLINE_API_TASK_DOCUMENT_BY_ID =
  '/task-service/tasks/{{taskId}}/documents/{{documentId}}';

export const SOFTLINE_API_WORKFLOWS = '/workflow-service/workflows';
export const SOFTLINE_API_WORKFLOW_CREATE = '/workflow-service/workflows/new';
export const SOFTLINE_API_WORKFLOW_TYPES = '/workflow-service/workflows/types';
export const SOFTLINE_API_WORKFLOWS_QUERY = '/workflow-service/workflows/query/{{type}}';
export const SOFTLINE_API_WORKFLOWS_ALL = '/workflow-service/workflows/query';
export const SOFTLINE_API_WORKFLOW_BY_ID = '/workflow-service/workflows/{{id}}';
export const SOFTLINE_API_WORKFLOW_NEXT_ACTION =
  '/workflow-service/workflows/{{id}}/next-action';
export const SOFTLINE_API_WORKFLOW_PARTICIPANTS =
  '/workflow-service/workflows/{{id}}/participants';
export const SOFTLINE_API_WORKFLOW_COMMENTS =
  '/workflow-service/workflows/{{workflowId}}/comments';
export const SOFTLINE_API_WORKFLOW_COMMENT_BY_ID =
  '/workflow-service/workflows/{{workflowId}}/comments/{{commentId}}';
export const SOFTLINE_API_WORKFLOW_HISTORY =
  '/workflow-service/workflows/{{workflowId}}/history';

export const SOFTLINE_API_CHECKLISTS = '/task-service/tasks/checklists';
export const SOFTLINE_API_CHECKLIST_BY_ID = '/task-service/tasks/checklists/{{id}}';
